<template>
  <v-dialog v-model="show" max-width="80%" scrollable>
    <v-card class="border" style="max-height: inherit;overflow-y: scroll;">
      <v-btn @click="close" elevation="0" color="red" class="close-btn align-self-end">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <div v-if="item" class="pa-10">
        <v-row>
          <v-col cols="12" md="12" class="mb-4">
            <h3>Edicion de costos</h3>
          </v-col>
        </v-row>
        <v-row class="mb-4">
          <v-col col="12" md="4" xl="4" class="mb-2">
            <span>
              <strong>ID Producto: </strong>
              {{ item.ID_Item }}
            </span>
          </v-col>
          <v-col col="12" md="4" xl="4" class="mb-2">
            <span>
              <strong>Nombre: </strong>
              {{ item.ItemName }}
            </span>
          </v-col>
          <v-col col="12" md="4" xl="4" class="mb-2">
            <span>
              <strong>Unidad: </strong>
              {{ item.ItemMeasureUnit }}
            </span>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col cols="12" md="3">
            <v-checkbox v-model="form.noDate" @change="getEarningDetailByItems" label="Editar todos los costos sin definir fecha de inicio."/>
          </v-col>
          <v-col cols="12" md="3" v-if="!form.noDate">
            <date-picker  label="Fecha inicio" @dateSelected="(param) => {form.dateStart = param; $emit('getOneDate', param) }"  class="mx-1" />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="form.newAmount" label="Nuevo monto" outlined dense type="number" />
          </v-col>
          <v-col col="12" md="3">
            <v-select v-model="form.warehouse" label="Almacén"
              :items="warehouses" item-text="name" item-value="value" attach
              outlined dense />
          </v-col>
        </v-row>
      </div>
      <v-card-actions class="mt-3">
        <v-btn @click="close" class="btndelete">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="btn-save" :disabled="!form.newAmount" @click="save">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from '@/components/DatePicker'

export default {
  name: 'EditAmountDialog',
  components: { DatePicker },
  props: {
    show: Boolean,
    item: Object,
    warehouses: Array,
    value: Boolean,
    initialWarehouse: [String, Number],
  },
  data() {
    return {
      form: {
        newAmount: null,
        warehouse: null,
        dateStart: null,
        noDate: false,
      },
    };
  },
  watch: {
    show(val) {
      if (val && this.item) {
        this.form = {
          newAmount: null,
          warehouse: this.initialWarehouse || (this.item.Warehouse || this.item.ID_Warehouse) || null,
        };
      }
    },
    initialWarehouse(val) {
      this.form.warehouse = val;
    }
  },
  computed: {
    warehouseName() {
      if (!this.form.warehouse) return '';
      const found = this.warehouses.find(w => w.value === this.form.warehouse);
      return found ? found.name : '';
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false);
      this.$emit('close');
    },
    save() {
      this.$emit('save', {
        id: this.item.ID_Item,
        newAmount: this.form.newAmount,
        warehouse: this.form.warehouse,
        dateStart: this.form.dateStart,
        noDate: this.form.noDate,
      });
      this.close();
    }
  }
};
</script>

<style scoped>
.close-btn {
  color: white !important;
  position: relative !important;
  float: right !important;
}
.border {
  border-radius: 15px !important;
}
</style>
